import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckboxWithLink } from '@mopla/ui';
import { useI18nLanguage } from '@mopla/utils';

interface IProps {
	checked: boolean;
	toggleCheckbox: VoidFunction;
}

const linkByLang: Record<string, string> = {
	de: 'https://www.mopla.solutions/de/datenschutz',
	en: 'https://www.mopla.solutions/de/datenschutz',
	fr: 'https://www.mopla.solutions/de/datenschutz',
	pl_PL: 'https://www.mopla.solutions/de/datenschutz',
	tr: 'https://www.mopla.solutions/de/datenschutz',
	cs: 'https://www.mopla.solutions/de/datenschutz',
	uk_UA: 'https://www.mopla.solutions/de/datenschutz',
};

interface IWithPrivacyPolicyLinkProps {
	render: (link: string) => ReactNode;
}

export const WithPrivacyPolicyLink: FC<IWithPrivacyPolicyLinkProps> = ({
	render,
}) => {
	const lng = useI18nLanguage();

	return <>{render(linkByLang[lng])}</>;
};

export const PrivacyPolicy: FC<IProps> = (props) => {
	const { checked, toggleCheckbox } = props;
	const { t } = useTranslation(['registration']);

	return (
		<WithPrivacyPolicyLink
			render={(link) => (
				<CheckboxWithLink
					testId="privacy-policy"
					url={link}
					linkText={
						t('text.check_terms_and_policy', {
							value: t('text.privacy_policy'),
						}) + '*'
					}
					checked={checked}
					toggleCheckbox={toggleCheckbox}
				/>
			)}
		/>
	);
};
